const CROP_ASPECT_RATIO = 16 / 9;
const EDGE_MARGIN_RATIO = 0.1;

export async function captureCenteredExpiryCrop(video: HTMLVideoElement): Promise<Blob> {
  const intrinsicWidth = video.videoWidth;
  const intrinsicHeight = video.videoHeight;
  const viewportWidth = video.clientWidth;
  const viewportHeight = video.clientHeight;

  if (!intrinsicWidth || !intrinsicHeight || !viewportWidth || !viewportHeight) {
    throw new Error('Camera preview is not ready yet');
  }

  const scale = Math.max(viewportWidth / intrinsicWidth, viewportHeight / intrinsicHeight);
  const displayedWidth = intrinsicWidth * scale;
  const displayedHeight = intrinsicHeight * scale;
  const offsetX = (displayedWidth - viewportWidth) / 2;
  const offsetY = (displayedHeight - viewportHeight) / 2;

  const maxCropViewportWidth = viewportWidth * (1 - EDGE_MARGIN_RATIO * 2);
  const maxCropViewportHeight = viewportHeight * (1 - EDGE_MARGIN_RATIO * 2);
  const cropViewportWidth = Math.min(maxCropViewportWidth, maxCropViewportHeight * CROP_ASPECT_RATIO);
  const cropViewportHeight = cropViewportWidth / CROP_ASPECT_RATIO;
  const cropViewportX = (viewportWidth - cropViewportWidth) / 2;
  const cropViewportY = (viewportHeight - cropViewportHeight) / 2;

  const sourceX = Math.max(0, Math.round((cropViewportX + offsetX) / scale));
  const sourceY = Math.max(0, Math.round((cropViewportY + offsetY) / scale));
  const sourceWidth = Math.min(
    intrinsicWidth - sourceX,
    Math.max(1, Math.round(cropViewportWidth / scale)),
  );
  const sourceHeight = Math.min(
    intrinsicHeight - sourceY,
    Math.max(1, Math.round(cropViewportHeight / scale)),
  );

  const canvas = document.createElement('canvas');
  canvas.width = sourceWidth;
  canvas.height = sourceHeight;

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Could not prepare image capture');
  }

  context.drawImage(
    video,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    0,
    0,
    sourceWidth,
    sourceHeight,
  );

  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', 0.92);
  });

  if (!blob) {
    throw new Error('Could not capture expiry photo');
  }

  return blob;
}
